<template>
    <div class="tag_hashed"
         :class="filter === tag.slug ? 'border-main-blue/50':'border-main-blue/0'"
         @click="condition ? loadStream() : select()">
        #{{ tag.name }}&nbsp;<span class="text-xxxs align-text-top">{{ tag?.content?.length }}</span>
    </div>
</template>
<script setup>
import {Event} from '@/shared/helpers.js';
import {router} from '@inertiajs/vue3';
import {ref} from 'vue';
const props = defineProps(['tag', 'filter']);

let condition = ref(true);
function loadStream() {
    // TODO: #03 реализовать сохранение выбранного пользователем поведения: открывать страницу контента или загружать данные по тегу в сайдбар
    router.get('/stream/' + props.tag.slug);
}
function select() {
    // fire event for change data in side component of ArticleShow
    Event.emit('new_tag_selected', props.tag);
}
</script>
<style>
.tag_hashed {
	@apply text-sm text-main-blue opacity-80 hover:opacity-100 cursor-pointer duration-150 border-b border-main-accent/0 hover:border-main-blue/70 mr-2
}
</style>
